module.exports = __webpack_public_path__ + "img/icon-video2.a4effaff.png";